import axios from '../http.service'
import config from '../../config'
const ApiBaseUrl = config.opapiHost
export default {
    //
    customer: (params) => {
        return axios.post(`${ApiBaseUrl}/web/customer`,params)
    },
}



// WEBPACK FOOTER //
// ./src/services/api/user.service.js